import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {HEADER_STATUS_CODE} from "@core/constants";
import {AuthService} from "@core/authentication/auth.service";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private requestMap = new Map<string, HttpRequest<any>>();

  constructor(
    private authService: AuthService,
  ) {
  }

  private errorPages = [
    HEADER_STATUS_CODE.FORBIDDEN,
    // HEADER_STATUS_CODE.NOT_FOUND,
    HEADER_STATUS_CODE.INTERNAL_SERVER_ERROR
  ];

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const clonedRequest = request.clone();
    this.requestMap.set(request.urlWithParams, clonedRequest);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => this.handleError(error)),
      // Final handle remove params
      finalize(() => this.requestMap.delete(request.urlWithParams))
    );
  }

  private handleError(error: HttpErrorResponse) {
    // 0. [DEBUG] Log mọi lỗi HTTP để xác định nguyên nhân
    console.log('[ErrorInterceptor] catchError:', {
      url: error.url,
      status: error.status,
      message: error.message,
      name: error.name
    });

    // Kiểm tra có đang ở trang public không — nếu có thì KHÔNG logout
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const isPublicPage = currentPath === '/' || currentPath === '' || currentPath.startsWith('/auth') || currentPath.startsWith('/checkout') || currentPath.startsWith('/pricing');

    // 1. Kiểm tra mã 401 Unauthorized — BE xác nhận user chưa đăng nhập hoặc token hết hạn
    if (error.status === HEADER_STATUS_CODE.UNAUTHORIZED || error.status === HEADER_STATUS_CODE.FOUND) {
      console.warn('[ErrorInterceptor] Nhận mã 401/302 từ BE →', isPublicPage ? 'đang ở trang public, bỏ qua logout' : 'logout', error.url);
      if (!isPublicPage) {
        this.authService.logout();
      }
      return throwError(() => error);
    }

    // 2. JSON parse error (status 200 nhưng body không phải JSON hợp lệ):
    // Server có thể trả về HTML thay vì JSON (misconfigured route, redirect ngầm, …).
    // KHÔNG tự động logout ở đây — đó không phải là auth error thực sự,
    // mà là lỗi server/api config. Log ra để debug.
    if (error.status === 200 || error.status === 0) {
      const currentOrigin = window.location.origin + '/';
      if (error.url === currentOrigin || error.url === window.location.origin) {
        console.warn(
          '[ErrorInterceptor] Request đến origin bị lỗi parse (có thể server trả HTML thay vì JSON)' +
          (isPublicPage ? ' — đang ở trang public, bỏ qua logout' : ' — logout để tránh loop'),
          {url: error.url, status: error.status, error: error.message}
        );
        if (!isPublicPage) {
          this.authService.logout();
        }
        return throwError(() => error);
      }
      // Các API URL khác: log cảnh báo nhưng KHÔNG logout
      console.warn(
        '[ErrorInterceptor] Response không parse được (status 200/0) — có thể server trả HTML thay vì JSON',
        {url: error.url, status: error.status, error: error.message}
      );
    }

    return throwError(() => error);
  }

}
